// extracted by mini-css-extract-plugin
export default {"table":"KwuquT7_VpI1_IyQXZcC","filter":"D7j4pRqGzqYdLP2PAxIa"};